import { db } from '@/firebase'

const clientRef = db.collection('clients')

export default {
  state: {
    createClientLoading: false
  },
  mutations: {
    toggleClientLoading (state, payload) {
      if (payload === undefined || payload === null) {
        state.createClientLoading = !state.createClientLoading
      } else {
        state.createClientLoading = payload
      }
    }
  },
  actions: {
    createClient ({ commit }, payload) {
      return clientRef.add(payload)
    },
    getClients ({ commit }) {
      return clientRef.get()
    },
    getClientDetail ({ commit }, id) {
      return clientRef.doc(id).get()
    },
    updateClientDetail ({ commit }, { id, ...payload }) {
      return clientRef.doc(id).set(payload, { merge: true })
    }
  },
  getters: {
    createClientLoading: (state) => state.createClientLoading
  }
}
